import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./i18n";
import i18n from "i18next"; // ✅ Add this line
import "./firebase";

i18n.on("languageChanged", (lng) => {
  document.body.setAttribute("dir", lng === "he" ? "rtl" : "ltr");
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
